import { ReactElement } from "react";

import { Help } from "_/components/form-field";

import * as S from "./styled";
import { ButtonProps } from "./types";

export type { ButtonKind, ButtonSize, ButtonVariant } from "./types";

export const ButtonGroup = S.ButtonGroup;

export const Button = (props: ButtonProps): ReactElement => {
  const {
    children,
    size = "medium",
    kind = "primary",
    variant = "contained",
    title,
    "aria-label": ariaLabel,
    round = false,
    iconOnly = false,
    helpContent,
    disabled,
    ...rest
  } = props;

  const button = (
    <S.Button
      $kind={kind}
      $size={size}
      $variant={variant}
      $iconOnly={iconOnly}
      $round={round}
      disabled={disabled}
      title={title}
      aria-label={ariaLabel ?? title}
      {...rest}
    >
      {children}
    </S.Button>
  );

  // Disabled <button> elements suppress pointer events on all children, making
  // an inline tooltip unreachable. Always render the help outside the button.
  if (helpContent) {
    return (
      <S.ButtonWrapper>
        {button}
        <S.InlineHelp>
          <Help content={helpContent} placement="bottomEnd" />
        </S.InlineHelp>
      </S.ButtonWrapper>
    );
  }

  return button;
};
